import type { CampaignInfluencerContact } from "@/marketing/models/campaignInfluencerContact";

interface ContactSectionProps {
  contact: CampaignInfluencerContact | null | undefined;
  isLoading: boolean;
  isError: boolean;
}

export function ContactSection({
  contact,
  isLoading,
  isError,
}: ContactSectionProps) {
  if (isLoading) {
    return (
      <p className="tw-text-[12px] tw-text-muted-foreground">Loading contact…</p>
    );
  }
  if (isError) {
    return <p className="tw-text-[12px] tw-text-rose-600">Failed to load contact.</p>;
  }
  if (!contact) {
    return (
      <p className="tw-text-[12px] tw-text-muted-foreground">
        No Creator Hub account linked.
      </p>
    );
  }

  const shipping = contact.address?.shipping;
  const streetLine = [shipping?.address1, shipping?.address2]
    .filter(Boolean)
    .join(", ");
  const regionLine = [
    shipping?.city,
    shipping?.state,
    shipping?.postcode,
    shipping?.country,
  ]
    .filter(Boolean)
    .join(", ");
  const hasAddress = Boolean(streetLine || regionLine);

  return (
    <dl className="tw-grid tw-grid-cols-[auto_1fr] tw-gap-x-3 tw-gap-y-1.5 tw-text-[12px]">
      <dt className="tw-text-muted-foreground">Email</dt>
      <dd className="tw-truncate tw-font-medium tw-text-foreground">
        {contact.email?.emailAddress || "—"}
      </dd>
      <dt className="tw-text-muted-foreground">Phone</dt>
      <dd className="tw-font-medium tw-text-foreground">{shipping?.phone || "—"}</dd>
      <dt className="tw-text-muted-foreground">Shipping</dt>
      <dd className="tw-font-medium tw-text-foreground">
        {hasAddress ? (
          <span>
            {streetLine}
            {streetLine && regionLine && <br />}
            {regionLine}
          </span>
        ) : (
          <span className="tw-text-muted-foreground">
            No shipping address on file
          </span>
        )}
      </dd>
    </dl>
  );
}
